import { alpha } from "@mui/material/styles";
import { blue, deepPurple, green, red } from "@mui/material/colors";

// ---------------------------------------------------------------------------
// The malnutrition card's colour system (ENG-30844). Four colours carry
// meaning, and nothing else on the card is allowed to use them:
//
//   red        -> clinical decline in the *data* — the weight delta, an
//                 out-of-range lab. Never a heading, chip or border, so a red
//                 pixel in the card's resting state always means the patient,
//                 not the section.
//
//                 Four things outside this file keep a red or green of their
//                 own, all deliberate and none drawing from the colours below:
//                 the discharge banner (a stock MUI <Alert> announcing an
//                 imminent event), the feedback Yes/No pills (green/red
//                 affirmation), the criteria follow-up panel (which carries the
//                 No's red), and the feedback save-failure message. The last
//                 three are UI state on a control the user is operating, not a
//                 reading about the patient — a different axis from clinical
//                 severity, and one the reader is never asked to interpret
//                 clinically.
//   green      -> the opposite reading in the data: a weight trend that rises.
//   blue       -> links only.
//   deepPurple -> Qventus-generated content — the quotes the model pulled, and
//                 the weight readings the trend is computed between (EBA's
//                 pair until the user picks others).
//
// Everything else is neutral grey. Colour is never the sole carrier: each of
// these is paired with a label ("Change", "Baseline"/"Latest") or, for the
// trend, its arrow.
// ---------------------------------------------------------------------------

// Matches theme palette.primary.main (see src/theme.tsx) so the card reads as
// one system with the rest of the app.
export const QVENTUS_PURPLE = deepPurple[600];
export const QVENTUS_PURPLE_EDGE = deepPurple[300];
export const QVENTUS_PURPLE_TEXT = deepPurple[700];
export const PURPLE_TINT = alpha(deepPurple[600], 0.08);

// The brand mark keeps its own purple — it's the logo, not a palette colour, so
// it doesn't move when the theme does.
export const BRAND_PURPLE = "#6700e5";

// Links. Set explicitly rather than inherited: the theme's primary is
// deepPurple, which would leave "Show N more" reading as Qventus-generated
// content and leave blue with no job on the card at all.
export const LINK_BLUE = blue[700];

// Clinical decline. Imported rather than reached for directly so the "red means
// one thing" rule is enforceable by grepping this file's importers.
export const DECLINE_RED = red[800];

// A gain. green[800] rather than the Yes pill's green[700], which falls short
// of 4.5:1 as text on the weights card's grey.
export const GAIN_GREEN = green[800];

// Criterion/rule cards: one faint border all round, replacing the coloured left
// edge that used to encode severity.
export const CARD_BORDER = "rgba(0, 0, 0, 0.12)";
